
import React, { useState, useEffect } from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '@/components/ui/card';
import { AnalysisProgress } from '@/components/AnalysisProgress';
import { SearchForm } from '@/components/home/SearchForm';
import { RecentSites } from '@/components/home/RecentSites';
import { ScanHistory } from '@/components/home/ScanHistory';
import { Footer } from '@/components/home/Footer';
import LanguageSwitcher from '@/components/LanguageSwitcher';
import BannerAd from '@/components/ads/BannerAd';
import { useTranslation } from 'react-i18next';
import { getScanHistory, AnalysisHistory } from '@/utils/analysisHelpers';

export default function Index() {
  const { t } = useTranslation();
  const [recentSites, setRecentSites] = useState<string[]>([]);
  const [scanHistory, setScanHistory] = useState<AnalysisHistory[]>([]);
  const [seoProgress, setSeoProgress] = useState(0);
  const [backlinkProgress, setBacklinkProgress] = useState(0);
  const [showProgress, setShowProgress] = useState(false);

  useEffect(() => {
    // Son ziyaret edilen siteleri yükle
    const sites = localStorage.getItem('recentSites');
    if (sites) {
      setRecentSites(JSON.parse(sites));
    }

    // Tarama geçmişini yükle
    const history = getScanHistory();
    setScanHistory(history);
  }, [t]);

  const addRecentSite = (domain: string) => {
    const updatedSites = [domain, ...recentSites.filter(site => site !== domain)].slice(0, 5);
    setRecentSites(updatedSites);
    localStorage.setItem('recentSites', JSON.stringify(updatedSites));
  };

  const simulateProgress = () => {
    setShowProgress(true);
    setSeoProgress(0);
    setBacklinkProgress(0);
    
    const seoInterval = setInterval(() => {
      setSeoProgress(prev => {
        if (prev >= 100) {
          clearInterval(seoInterval);
          return 100;
        }
        return prev + 5;
      });
    }, 500);
    
    const backlinkInterval = setInterval(() => {
      setBacklinkProgress(prev => {
        if (prev >= 100) {
          clearInterval(backlinkInterval);
          return 100;
        }
        return prev + 3;
      });
    }, 400);
    
    return () => {
      clearInterval(seoInterval);
      clearInterval(backlinkInterval);
      setShowProgress(false);
    };
  };

  const handleSiteSelect = (site: string) => {
    document.querySelector('input[type="url"]')?.setAttribute('value', `https://${site}`);
  };

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4">
      <LanguageSwitcher />
      
      {/* Top Banner Ad */}
      <BannerAd 
        format="horizontal" 
        slot="3456789012" 
        className="w-full max-w-4xl mb-6 h-[90px]" 
      />
      
      <Card className="w-full max-w-lg p-6 space-y-6">
        <CardHeader className="text-center p-0">
          <CardTitle className="text-3xl font-bold">LLMS.txt {t('app.generator')}</CardTitle>
          <CardDescription>
            {t('app.description')}
          </CardDescription>
          <CardDescription className="text-sm">
            {t('app.freeFeatures')}
          </CardDescription>
        </CardHeader>
        
        <CardContent className="p-0 space-y-4">
          <SearchForm 
            addRecentSite={addRecentSite} 
            simulateProgress={simulateProgress} 
          />
          
          {/* In-Content Ad */}
          <BannerAd 
            format="rectangle" 
            slot="7654321098" 
            className="w-full h-[250px] my-4" 
          />
          
          {scanHistory.length > 0 ? (
            <ScanHistory history={scanHistory} />
          ) : (
            <RecentSites 
              sites={recentSites} 
              onSiteSelect={handleSiteSelect} 
            />
          )}
        </CardContent>
        
        <CardFooter className="flex flex-col space-y-4 p-0">
          <Footer />
        </CardFooter>
      </Card>
      
      {/* Bottom Banner Ad */}
      <BannerAd 
        format="horizontal" 
        slot="5432109876" 
        className="w-full max-w-4xl mt-6 h-[90px]" 
      />

      <AnalysisProgress 
        seoProgress={seoProgress} 
        backlinkProgress={backlinkProgress} 
        isVisible={showProgress}
      />
    </div>
  );
}
